import controller from './kform-tab-file.controller';
import template from './kform-tab-file.html';
import './kform-tab-file.scss';

export default {
	controller,
	template,
	bindings: {
		form:     '<?',
		file:     '=?',
		kid:      '<',
		disabled: '<?ngDisabled',
		onLoad:   '&?',
	},
	require: {
		content: '^^?kformContent',
		kform:   '^^?kform',
	},
};
